let klaviyoPopupScrollObserver;

function restoreKlaviyoPopupBlock() {
  let promo;
  try {
    promo = JSON.parse(localStorage.getItem("promo_code") || "null");
  } catch {
    return false;
  }

  if (
    !promo || Array.isArray(promo) ||
    typeof promo.code !== "string" || !promo.code.trim() ||
    typeof promo.coupon_code !== "string" || !promo.coupon_code.trim()
  ) return false;

  blockKlaviyoPopup();
  return true;
}

function blockKlaviyoPopup() {
  if (document.getElementById("block-klaviyo-popup")) return;

  const popupSelector = 'div[role="dialog"][aria-modal="true"][aria-label^="Welcome form"]';
  const style = document.createElement("style");
  style.id = "block-klaviyo-popup";

  style.innerHTML = `
    ${popupSelector}{
      display:none !important;
    }
  `;

  document.head.appendChild(style);

  function releaseBlockedPopupScroll() {
    const scrollLockClass = "klaviyo-prevent-body-scrolling";
    const lockedElements = [document.documentElement, document.body].filter(
      (element) => element && element.classList.contains(scrollLockClass)
    );
    if (!lockedElements.length) return;

    const hasVisiblePopup = Array.from(
      document.querySelectorAll('[data-kl-scroll-locking-modal="true"]')
    ).some((popup) => !popup.matches(popupSelector) && popup.getClientRects().length > 0);
    if (hasVisiblePopup) return;

    lockedElements.forEach((element) => element.classList.remove(scrollLockClass));
  }

  klaviyoPopupScrollObserver = new MutationObserver(releaseBlockedPopupScroll);
  // Klaviyo locks scrolling through a class on the page roots. Gallery and
  // product updates do not need to trigger scroll-lock cleanup.
  [document.documentElement, document.body].filter(Boolean).forEach((element) => {
    klaviyoPopupScrollObserver.observe(element, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });
  releaseBlockedPopupScroll();
}

function unblockKlaviyoPopup() {
  klaviyoPopupScrollObserver?.disconnect();
  klaviyoPopupScrollObserver = null;
  const style = document.getElementById("block-klaviyo-popup");
  if (style) style.remove();
}

restoreKlaviyoPopupBlock();
window.addEventListener("pageshow", restoreKlaviyoPopupBlock);
